<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>Permissions</h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button *ngIf="tabIndex === 0" class="action-button d-flex col-auto align-items-center"
                (click)="onCreateRoleClick()">
                <mat-icon>add</mat-icon>
                Create Role
            </button>
            <button mat-raised-button *ngIf="tabIndex !== 0" class="action-button"
                [disabled]="isSaving()"
                (click)="onSaveClick()">
                <mat-spinner *ngIf="isSaving()" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isSaving()">save</mat-icon>
                {{ isSaving() ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>
    <mat-card class="mt-3 pb-3">
        <mat-tab-group animationDuration="0ms" dynamicHeight mat-align-tabs="center" class="pt-2"
            (selectedTabChange)="tabChanged($event)">
            <mat-tab label="Role">
                <app-roles (rolesChanged)="onRolesChanged()"></app-roles>
            </mat-tab>
            <mat-tab label="Assignment">
                <app-assignment></app-assignment>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</div>
